const allowUser=['EX_CSEYE','CSYFTD']

export function isAllowUser(userId) {
  // console.log(userId,allowUser.some(element => userId.includes(element)))
  return allowUser.some(element => userId.includes(element))
}